/* sticky-atc.js v2026-04-22h — cart-aware remaining (inv - inCartQty) */
(function() {
  'use strict';

  var EXPERIMENT_ID = 'EXP3003B277';
  var VARIATION_ID = '1';
  var SCROLL_TRIGGER = 0.20;

  // ── Event tracking ─────────────────────────────────────────────────
  function trackEvent() { /* removed Variant analytics — no-op */ }

  function initStickyATC(retryCount) {
    if (document.getElementById('vr-sticky-atc-bar')) return;
    retryCount = retryCount || 0;

    getAllVariants().then(function(variantData) {
      if ((!variantData || variantData.length === 0) && retryCount < 3) {
        setTimeout(function() { initStickyATC(retryCount + 1); }, 800 * (retryCount + 1));
        return;
      }
      if (!variantData || variantData.length === 0) return;

      enrichWithSwatchImages(variantData);
      computeStockProfile(variantData);

      var sortedVariants = sortVariantsByAvailability(variantData);
      var currentVariantId = getCurrentVariantId(variantData);
      var currentVariant = variantData.find(function(v) { return v.id === currentVariantId; })
        || sortedVariants.find(function(v) { return v.available; })
        || sortedVariants[0];

      var state = {
        selectedVariant: currentVariant,
        quantity: getPageQuantity(),
        isVisible: false,
        isAdding: false,
        isDropdownOpen: false
      };

      injectStyles();
      var bar = buildStickyBar(sortedVariants, state);
      document.body.appendChild(bar);
      updateQuantityDisplay(state, bar);

      setupScrollListener(state, bar);
      setupPageSyncListener(state, sortedVariants, bar);
      updateInCartIndicator(state, bar);
      setTimeout(function() { updateInCartIndicator(state, bar); }, 800);
      setTimeout(function() { updateInCartIndicator(state, bar); }, 2500);
      document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'visible') updateInCartIndicator(state, bar);
      });
      window.addEventListener('pageshow', function() { updateInCartIndicator(state, bar); });

      // Refresh in-cart indicator whenever the cart changes anywhere on the page
      ['cart:refresh', 'cart:updated', 'cart:added'].forEach(function(evt) {
        document.addEventListener(evt, function() { updateInCartIndicator(state, bar); });
      });
      // Intercept native cart mutations so we can refresh after any add/change/update
      (function() {
        var origFetch = window.fetch;
        if (!origFetch || origFetch.__vrStickyPatched) return;
        window.fetch = function() {
          var args = arguments;
          var url = args[0];
          var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
          var result = origFetch.apply(window, args);
          if (/\/cart\/(add|change|update|clear)(\.js)?/.test(urlStr)) {
            result.then(function() {
              setTimeout(function() { updateInCartIndicator(state, bar); }, 150);
            }).catch(function(){});
          }
          return result;
        };
        window.fetch.__vrStickyPatched = true;
      })();

      // Close the variant dropdown when tapping anywhere outside the sticky bar
      document.addEventListener('click', function(e) {
        if (!state.isDropdownOpen) return;
        if (!bar.contains(e.target)) {
          closeDropdown(state, bar);
        }
      }, true);

      // Also close dropdown if user starts scrolling the page
      window.addEventListener('scroll', function() {
        if (state.isDropdownOpen) {
          closeDropdown(state, bar);
        }
      }, { passive: true });

      setupCartDrawerWatcher(state, bar);

    }).catch(function() {
      if (retryCount < 3) {
        setTimeout(function() { initStickyATC(retryCount + 1); }, 800 * (retryCount + 1));
      }
    });
  }

  // ── Data helpers ──────────────────────────────────────────────────────

  // Stores the Shopify product ID for the current page so attribution
  // works on every product, not just a single hard-coded one.
  var _resolvedProductId = null;

  function getAllVariants() {
    var handle = getProductHandle();
    if (handle) {
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(rootUrl + 'products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          if (product && product.id) {
            _resolvedProductId = String(product.id);
          }
          if (product && product.variants && product.variants.length > 0) {
            var productTitle = product.title || '';
            return product.variants.map(function(v) {
              var imgSrc = null;
              if (v.featured_image && v.featured_image.src) {
                imgSrc = v.featured_image.src;
                if (imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
              }
              var isDefault = v.title === 'Default Title';
              return {
                id: v.id,
                title: isDefault ? productTitle : v.title,
                public_title: isDefault ? productTitle : (v.public_title || v.title),
                price: v.price,
                compare_at_price: v.compare_at_price,
                available: v.available,
                options: v.options || [v.option1, v.option2, v.option3].filter(Boolean),
                option1: v.option1,
                option2: v.option2,
                option3: v.option3,
                image: imgSrc || (product.featured_image ? product.featured_image : null),
                inventory_quantity: typeof v.inventory_quantity === 'number' ? v.inventory_quantity : null,
                inventory_management: v.inventory_management,
                _isSingleVariant: isDefault
              };
            });
          }
          return fallbackGetVariants();
        })
        .catch(function() {
          return fallbackGetVariants();
        });
    }
    return Promise.resolve(fallbackGetVariants());
  }

  /**
   * Pull images from swatch elements on the page for any variants missing an image.
   * Swatch items contain background-image URLs mapped by variant title.
   */
  function enrichWithSwatchImages(variants) {
    try {
      var swatchItems = document.querySelectorAll('.swatch-view-item');
      swatchItems.forEach(function(li) {
        var origValue = li.getAttribute('orig-value');
        if (!origValue) return;
        var imgDiv = li.querySelector('.star-set-image');
        if (!imgDiv) return;
        var bgImg = imgDiv.style.backgroundImage;
        if (!bgImg) return;
        var urlMatch = bgImg.match(/url\(["']?([^"')]+)["']?\)/);
        if (!urlMatch) return;
        var imgUrl = urlMatch[1].replace(/&amp;/g, '&');

        variants.forEach(function(v) {
          var vTitle = v.public_title || v.title;
          if (vTitle === origValue && !v.image) {
            v.image = imgUrl;
          }
        });
      });
    } catch(e) {}
  }

  function getProductHandle() {
    try {
      var picker = document.querySelector('variant-picker.product-form__variants[handle]');
      if (picker) return picker.getAttribute('handle');
      var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
      if (match) return match[1];
    } catch(e) {}
    return null;
  }

  function fallbackGetVariants() {
    var variants = [];
    try {
      var select = document.querySelector('variant-picker.product-form__variants[form-id*="product-form-main"] select[name="id"]');
      if (!select) select = document.querySelector('select[name="id"]');
      if (select) {
        var options = select.querySelectorAll('option');
        options.forEach(function(opt) {
          var text = opt.textContent.trim();
          var priceMatch = text.match(/\$([0-9]+(?:\.[0-9]+)?)/);
          var price = priceMatch ? Math.round(parseFloat(priceMatch[1]) * 100) : 0;
          var name = text.replace(/\s*-\s*\$[0-9]+(?:\.[0-9]+)?.*$/, '').trim();
          variants.push({
            id: parseInt(opt.value, 10),
            title: name,
            public_title: name,
            price: price,
            compare_at_price: null,
            available: !opt.disabled,
            options: [name],
            option1: name,
            image: null,
            inventory_quantity: null,
            inventory_management: null
          });
        });
      }
      if (variants.length === 0) {
        var radios = document.querySelectorAll('variant-picker.product-form__variants[form-id*="product-form-main"] .block-swatch__radio');
        radios.forEach(function(radio) {
          var label = radio.nextElementSibling;
          if (!label) return;
          var name = label.getAttribute('title') || label.textContent.trim();
          variants.push({
            id: parseInt(radio.value, 10),
            title: name,
            public_title: name,
            price: 0,
            compare_at_price: null,
            available: true,
            options: [name],
            option1: name,
            image: null,
            inventory_quantity: null,
            inventory_management: null
          });
        });
      }
    } catch(e) {}
    return variants;
  }

  function getCurrentVariantId(variants) {
    try {
      // Try swatch app first (it replaces the native variant picker)
      var selectedSwatch = document.querySelector('.swatch-image.swatch-selected[data-value]');
      if (selectedSwatch) {
        var swatchVal = selectedSwatch.getAttribute('data-value');
        var swatchMatch = variants.find(function(v) {
          return v.title === swatchVal || v.public_title === swatchVal;
        });
        if (swatchMatch) return swatchMatch.id;
      }

      // Try native variant picker radios
      var mainPicker = document.querySelector('variant-picker.product-form__variants[form-id*="product-form-main"]');
      if (mainPicker) {
        var radios = mainPicker.querySelectorAll('.block-swatch__radio');
        for (var j = 0; j < radios.length; j++) {
          if (radios[j].checked) {
            var label = radios[j].nextElementSibling;
            if (label) {
              var title = label.getAttribute('title') || label.textContent.trim();
              var found = variants.find(function(v) {
                return v.title === title || v.public_title === title;
              });
              if (found) return found.id;
            }
          }
        }
      }

      // Try URL param
      var urlParams = new URLSearchParams(window.location.search);
      var urlVariant = urlParams.get('variant');
      if (urlVariant) return parseInt(urlVariant, 10);

      // Fallback to first available
      var avail = variants.find(function(v) { return v.available; });
      return avail ? avail.id : variants[0].id;
    } catch(e) {
      return variants[0] ? variants[0].id : null;
    }
  }

  function getPageQuantity() {
    try {
      var qtyInput = document.querySelector('quantity-picker.quantity-selector--product .quantity-selector__value');
      if (qtyInput) return parseInt(qtyInput.value, 10) || 1;
    } catch(e) {}
    return 1;
  }

  function sortVariantsByAvailability(variants) {
    // Price asc (cheapest first), inventory_quantity desc as tiebreaker.
    function sortByPrice(a, b) {
      var pa = typeof a.price === 'number' ? a.price : parseFloat(a.price) || 0;
      var pb = typeof b.price === 'number' ? b.price : parseFloat(b.price) || 0;
      if (pa !== pb) return pa - pb;
      return (b.inventory_quantity || 0) - (a.inventory_quantity || 0);
    }
    var available = variants.filter(function(v) { return v.available; }).sort(sortByPrice);
    var soldOut = variants.filter(function(v) { return !v.available; }).sort(sortByPrice);
    return available.concat(soldOut);
  }

  function formatPrice(cents) {
    return '$' + (cents / 100).toFixed(2) + ' CAD';
  }

  /**
   * Returns true when the variant is on sale (compare_at_price > price).
   */
  function isOnSale(variant) {
    return variant.compare_at_price && variant.compare_at_price > variant.price;
  }

  /**
   * Build an HTML string that shows current price + struck-through
   * compare-at price when the variant is on sale.
   */
  function formatPriceHtml(variant) {
    if (isOnSale(variant)) {
      return '<span class="vr-price-sale">' + formatPrice(variant.price) + '</span>' +
             '<span class="vr-price-compare">' + formatPrice(variant.compare_at_price) + '</span>';
    }
    return escapeHtml(formatPrice(variant.price));
  }

  function resizeImage(url, width) {
    if (!url) return '';
    return url.replace(/(\.(jpg|jpeg|png|webp|gif))(\?|$)/i, '_' + width + 'x$1$3');
  }

  // ── Smart inventory messaging ─────────────────────────────────────────
  //
  // Analyses stock levels *relative* to all sibling variants so that
  // thresholds adapt to each product's actual inventory profile.
  //
  // Users are randomly bucketed into one of three copy styles so we can
  // measure which language drives the most add-to-carts:
  //   A – exact count  ("Only 5 left!")
  //   B – social proof  ("Selling fast \u2013 almost gone")
  //   C – action nudge  ("Grab yours \u2013 limited qty")
  //
  // Slow-moving variants (high stock relative to average) get their own
  // persuasion copy to encourage trial.

  var _copyBucket = null;
  function getCopyBucket() {
    if (_copyBucket) return _copyBucket;
    var stored = null;
    try { stored = sessionStorage.getItem('vr_copy_bucket'); } catch(e) {}
    if (stored && ['A','B','C'].indexOf(stored) !== -1) {
      _copyBucket = stored;
      return _copyBucket;
    }
    var r = Math.random();
    _copyBucket = r < 0.34 ? 'A' : r < 0.67 ? 'B' : 'C';
    try { sessionStorage.setItem('vr_copy_bucket', _copyBucket); } catch(e) {}
    return _copyBucket;
  }

  /**
   * Pre-compute percentile thresholds from all available variants so
   * that "low" and "medium" adapt to the product's stock profile.
   */
  var _stockProfile = null;
  function computeStockProfile(allVariants) {
    if (_stockProfile) return _stockProfile;
    var quantities = allVariants
      .filter(function(v) { return v.available && typeof v.inventory_quantity === 'number' && v.inventory_quantity > 0; })
      .map(function(v) { return v.inventory_quantity; })
      .sort(function(a, b) { return a - b; });

    if (quantities.length === 0) {
      _stockProfile = { p25: 5, median: 15, p75: 30, mean: 15 };
      return _stockProfile;
    }

    function percentile(arr, p) {
      var idx = (p / 100) * (arr.length - 1);
      var lo = Math.floor(idx);
      var hi = Math.ceil(idx);
      if (lo === hi) return arr[lo];
      return arr[lo] + (arr[hi] - arr[lo]) * (idx - lo);
    }

    var sum = quantities.reduce(function(a, b) { return a + b; }, 0);
    _stockProfile = {
      p25: percentile(quantities, 25),
      median: percentile(quantities, 50),
      p75: percentile(quantities, 75),
      mean: sum / quantities.length
    };
    return _stockProfile;
  }

  /**
   * Check if a variant is flagged as new by the merchant (has *NEW* in title).
   */
  function isNewFlavour(variant) {
    var title = (variant.public_title || variant.title || '').toUpperCase();
    return title.indexOf('*NEW*') !== -1 || title.indexOf('NEW!') !== -1;
  }

  function getInventoryInfo(variant, allVariants) {
    if (!variant.available) {
      return { text: 'Sold out', tier: 'out' };
    }
    var qty = variant.inventory_quantity;
    if (qty === null || qty === undefined) return null;
    if (qty <= 0) return { text: 'Sold out', tier: 'out' };

    var profile = computeStockProfile(allVariants || []);
    var bucket = getCopyBucket();
    var isNew = isNewFlavour(variant);

    // New flavours get a dedicated badge regardless of stock level
    if (isNew) {
      return { text: 'New Flavour', tier: 'new' };
    }

    // ── Critical: at or below 25th-percentile (or absolute <=5) ──
    if (qty <= Math.max(profile.p25, 5)) {
      if (bucket === 'A') return { text: 'Only ' + qty + ' left!', tier: 'low' };
      if (bucket === 'B') return { text: 'Selling fast \u2013 almost gone', tier: 'low' };
      return { text: 'Grab yours \u2013 limited qty', tier: 'low' };
    }

    // ── Below median: moderately low ──
    if (qty <= profile.median) {
      if (bucket === 'A') return { text: qty + ' left \u2013 going quick', tier: 'medium' };
      if (bucket === 'B') return { text: 'Popular \u2013 selling fast', tier: 'medium' };
      return { text: 'Don\u2019t miss out \u2013 low stock', tier: 'medium' };
    }

    // ── Above median but below 75th pct: healthy ──
    if (qty <= profile.p75) {
      if (bucket === 'A') return { text: 'In stock \u2013 ' + qty + ' available', tier: 'high' };
      if (bucket === 'B') return { text: 'Customer favorite', tier: 'high' };
      return { text: 'Available \u2013 order now', tier: 'high' };
    }

    // ── Above 75th pct: well-stocked ──
    if (bucket === 'A') return { text: 'In stock \u2013 ready to ship', tier: 'high' };
    if (bucket === 'B') return { text: 'Fan favorite \u2013 well stocked', tier: 'high' };
    return { text: 'Available \u2013 ships today', tier: 'high' };
  }

  // ── Styles ────────────────────────────────────────────────────────────

  function injectStyles() {
    if (document.getElementById('vr-sticky-atc-styles')) return;

    var css = [
      '#vr-sticky-atc-bar {',
      '  position: fixed; bottom: 0; left: 0; right: 0;',
      '  z-index: 2147483647;',
      '  background: #ffffff;',
      '  box-shadow: 0 -2px 12px rgba(0,0,0,0.12);',
      '  transform: translateY(100%);',
      '  transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1);',
      '  font-family: Barlow, sans-serif;',
      '  -webkit-font-smoothing: antialiased;',
      '}',
      '#vr-sticky-atc-bar.is-visible { transform: translateY(0); }',
      '#vr-sticky-atc-bar.vr-cart-open {',
      '  display: none !important;',
      '}',
      '',
      '.vr-sticky-inner {',
      '  padding: 10px 16px; max-width: 100%;',
      '  padding-bottom: max(10px, env(safe-area-inset-bottom, 10px));',
      '}',
      '',
      '/* ── Top row: image + variant + price ── */',
      '.vr-sticky-top-row {',
      '  display: flex; align-items: center; gap: 8px;',
      '  margin-bottom: 8px;',
      '}',
      '',
      '.vr-sticky-thumb {',
      '  width: 40px; height: 40px; border-radius: 6px;',
      '  object-fit: cover; flex-shrink: 0;',
      '  border: 1px solid #e1e3e4; background: #f3f5f6;',
      '}',
      '',
      '.vr-sticky-variant-wrap { flex: 1; min-width: 0; position: relative; }',
      '',
      '.vr-sticky-variant-btn {',
      '  display: flex; align-items: center; justify-content: space-between;',
      '  width: 100%; min-height: 38px;',
      '  padding: 6px 12px;',
      '  background: #f3f5f6; border: 1.5px solid #e1e3e4; border-radius: 8px;',
      '  font-family: Barlow, sans-serif; font-size: 13px; font-weight: 500;',
      '  color: #1e2d7d; cursor: pointer;',
      '  transition: border-color 0.15s ease;',
      '  text-align: left;',
      '}',
      '.vr-sticky-variant-btn:active { border-color: #006fdb; }',
      '',
      '.vr-sticky-variant-label {',
      '  flex: 1; min-width: 0;',
      '  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;',
      '}',
      '.vr-sticky-variant-arrow {',
      '  width: 0; height: 0; flex-shrink: 0; margin-left: 6px;',
      '  border-left: 5px solid transparent; border-right: 5px solid transparent;',
      '  border-top: 5px solid #1e2d7d;',
      '  transition: transform 0.2s ease;',
      '}',
      '.vr-sticky-variant-arrow.is-open { transform: rotate(180deg); }',
      '',
      '.vr-sticky-price {',
      '  font-size: 15px; font-weight: 700; color: #006fdb;',
      '  white-space: nowrap; flex-shrink: 0;',
      '  display: flex; flex-direction: column; align-items: flex-end; gap: 1px; line-height: 1.2;',
      '}',
      '.vr-price-sale { color: #ee0000; }',
      '.vr-price-compare {',
      '  font-size: 11px; font-weight: 500; color: #8a9297;',
      '  text-decoration: line-through;',
      '}',
      '',
      '.vr-dd-price .vr-price-sale { color: #ee0000; font-size: inherit; }',
      '.vr-dd-price .vr-price-compare {',
      '  font-size: 10px; font-weight: 500; color: #8a9297;',
      '  text-decoration: line-through; margin-left: 4px;',
      '}',
      '',
      '/* ── Dropdown ── */',
      '.vr-sticky-dropdown {',
      '  display: none; position: absolute; left: -56px; right: 0;',
      '  bottom: calc(100% + 6px);',
      '  background: #fff; border: 1px solid #e1e3e4;',
      '  border-radius: 10px; box-shadow: 0 -4px 20px rgba(0,0,0,0.12);',
      '  max-height: 55vh; overflow-y: auto;',
      '  -webkit-overflow-scrolling: touch;',
      '  z-index: 10;',
      '}',
      '.vr-sticky-dropdown.is-open { display: block; }',
      '',
      '.vr-sticky-dropdown-item {',
      '  display: flex; align-items: center; gap: 10px;',
      '  padding: 8px 12px; cursor: pointer;',
      '  font-family: Barlow, sans-serif; font-size: 13px; font-weight: 500;',
      '  color: #1e2d7d; border-bottom: 1px solid #f3f5f6;',
      '  transition: background 0.12s ease;',
      '}',
      '.vr-sticky-dropdown-item:last-child { border-bottom: none; }',
      '.vr-sticky-dropdown-item:active { background: rgba(0,111,219,0.06); }',
      '.vr-sticky-dropdown-item.is-selected {',
      '  background: rgba(0,111,219,0.08); font-weight: 600;',
      '}',
      '.vr-sticky-dropdown-item.is-soldout {',
      '  color: #8a9297; cursor: default;',
      '}',
      '',
      '.vr-dd-img {',
      '  width: 42px; height: 42px; border-radius: 5px;',
      '  object-fit: cover; flex-shrink: 0;',
      '  border: 1px solid #e1e3e4; background: #f3f5f6;',
      '}',
      '.vr-sticky-dropdown-item.is-selected .vr-dd-img {',
      '  border-color: #006fdb;',
      '}',
      '.vr-sticky-dropdown-item.is-soldout .vr-dd-img { opacity: 0.5; }',
      '',
      '.vr-dd-info {',
      '  flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px;',
      '}',
      '.vr-dd-name {',
      '  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;',
      '  line-height: 1.3;',
      '}',
      '.vr-dd-meta {',
      '  display: flex; align-items: center; gap: 6px; flex-wrap: wrap;',
      '}',
      '',
      '.vr-dd-price {',
      '  font-size: 12px; color: #006fdb; font-weight: 600;',
      '  white-space: nowrap;',
      '}',
      '.vr-sticky-dropdown-item.is-soldout .vr-dd-price { color: #8a9297; }',
      '',
      '.vr-dd-stock {',
      '  font-size: 10px; font-weight: 600; white-space: nowrap;',
      '  display: flex; align-items: center; gap: 3px;',
      '}',
      '.vr-dd-stock-dot {',
      '  width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0;',
      '}',
      '.vr-dd-stock.tier-high { color: #008a00; }',
      '.vr-dd-stock.tier-high .vr-dd-stock-dot { background: #008a00; }',
      '.vr-dd-stock.tier-medium { color: #b8860b; }',
      '.vr-dd-stock.tier-medium .vr-dd-stock-dot { background: #b8860b; }',
      '.vr-dd-stock.tier-low { color: #ee0000; }',
      '.vr-dd-stock.tier-low .vr-dd-stock-dot { background: #ee0000; animation: vr-pulse 1.4s ease-in-out infinite; }',
      '.vr-dd-stock.tier-out { color: #8a9297; }',
      '.vr-dd-stock.tier-out .vr-dd-stock-dot { background: #8a9297; }',
      '.vr-dd-stock.tier-new { color: #fff; background: #008a00; border-radius: 4px; padding: 1px 6px; font-size: 9px; text-transform: uppercase; letter-spacing: 0.4px; }',
      '.vr-dd-stock.tier-new .vr-dd-stock-dot { display: none; }',
      '@keyframes vr-pulse { 0%,100% { opacity:1; transform:scale(1); } 50% { opacity:.5; transform:scale(1.4); } }',
      '',
      '.vr-dd-soldout-badge {',
      '  font-size: 10px; background: #f3f5f6; border-radius: 4px;',
      '  padding: 2px 6px; color: #8a9297; font-weight: 600;',
      '  text-transform: uppercase; letter-spacing: 0.3px; flex-shrink: 0;',
      '}',
      '',
      '/* ── Bottom row ── */',
      '.vr-sticky-bottom-row {',
      '  display: flex; align-items: center; gap: 8px;',
      '}',
      '',
      '.vr-sticky-qty {',
      '  display: flex; align-items: center;',
      '  border: 1.5px solid #e1e3e4; border-radius: 8px;',
      '  height: 44px; flex-shrink: 0; overflow: hidden;',
      '}',
      '.vr-sticky-qty-btn {',
      '  width: 36px; height: 100%; border: none; background: none;',
      '  cursor: pointer; font-size: 18px; font-weight: 600; color: #1e2d7d;',
      '  font-family: Barlow, sans-serif; display: flex; align-items: center;',
      '  justify-content: center; transition: background 0.12s;',
      '  user-select: none; -webkit-user-select: none;',
      '}',
      '.vr-sticky-qty-btn:active { background: #f3f5f6; }',
      '.vr-sticky-qty-btn:disabled { color: #c8cbcd; cursor: not-allowed; }',
      '.vr-sticky-qty-val {',
      '  width: 30px; text-align: center; font-size: 14px; font-weight: 600;',
      '  color: #1e2d7d; font-family: Barlow, sans-serif; line-height: 44px;',
      '  user-select: none; -webkit-user-select: none;',
      '}',
      '',
      '.vr-sticky-atc-btn {',
      '  flex: 1; height: 44px; border: none; border-radius: 8px;',
      '  background: #fcdd00; color: #1e2d7d;',
      '  font-family: Barlow, sans-serif; font-size: 15px; font-weight: 600;',
      '  cursor: pointer; transition: background 0.2s ease, transform 0.1s ease;',
      '  text-transform: uppercase; letter-spacing: 0.3px;',
      '  display: flex; align-items: center; justify-content: center; gap: 6px;',
      '}',
      '.vr-sticky-atc-btn:active { transform: scale(0.98); }',
      '.vr-sticky-atc-btn:disabled { opacity: 0.5; cursor: not-allowed; }',
      '.vr-sticky-atc-btn.is-loading { pointer-events: none; opacity: 0.7; }',
      '.vr-sticky-atc-btn.is-success { background: #008a00; color: #fff; }',
      '.vr-sticky-atc-btn.is-soldout {',
      '  background: #eaeaea; color: #8a9297; cursor: not-allowed;',
      '}',
      '',
      '.vr-sticky-overlay {',
      '  display: none; position: fixed; top: 0; left: 0; right: 0; bottom: 0;',
      '  z-index: 2147483646; background: rgba(0,0,0,0.25);',
      '}',
      '.vr-sticky-overlay.is-open { display: block; }',
      '',
      '.vr-sticky-spinner {',
      '  width: 18px; height: 18px; border: 2.5px solid rgba(30,45,125,0.2);',
      '  border-top-color: #1e2d7d; border-radius: 50%;',
      '  animation: vr-sticky-spin 0.7s linear infinite;',
      '}',
      '@keyframes vr-sticky-spin { to { transform: rotate(360deg); } }',
      '.vr-sticky-atc-btn.is-success .vr-sticky-spinner { display: none; }',
      '',
      '.vr-sticky-soldout-sep {',
      '  padding: 6px 14px; font-size: 10px; font-weight: 600;',
      '  color: #8a9297; text-transform: uppercase; letter-spacing: 0.5px;',
      '  background: #f9fafb; border-bottom: 1px solid #f3f5f6;',
      '}',
      '',
      '.vr-sticky-qty-warn {',
      '  display: none; text-align: center;',
      '  font-size: 11px; font-weight: 600; color: #ee0000;',
      '  padding: 4px 0 0; font-family: Barlow, sans-serif;',
      '  line-height: 1.2;',
      '}',
      '.vr-sticky-qty-warn.is-visible { display: block; }',
      '',
      '.vr-sticky-in-cart {',
      '  display: none;',
      '  font-family: Barlow, sans-serif;',
      '  font-size: 11px; font-weight: 500;',
      '  color: #637381;',
      '  padding: 0 2px 6px;',
      '  line-height: 1.2;',
      '}',
      '.vr-sticky-in-cart.is-visible { display: block; }',
      '.vr-sticky-in-cart strong { color: #1e2d7d; font-weight: 700; }',
      '',
      '.vr-sticky-all-in-cart {',
      '  display: none;',
      '  font-family: Barlow, sans-serif;',
      '  font-size: 11px; font-weight: 700;',
      '  color: #d32d2d;',
      '  text-align: center;',
      '  padding: 4px 0 0;',
      '  line-height: 1.2;',
      '}',
      '.vr-sticky-all-in-cart.is-visible { display: block; }',
      '',
      '.vr-sticky-atc-btn.is-maxed {',
      '  background: #dfe3e8 !important;',
      '  color: #454f54 !important;',
      '  cursor: not-allowed !important;',
      '  box-shadow: none !important;',
      '}'
    ].join('\n');

    var style = document.createElement('style');
    style.id = 'vr-sticky-atc-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  // ── Build DOM ─────────────────────────────────────────────────────────

  function buildStickyBar(sortedVariants, state) {
    var bar = document.createElement('div');
    bar.id = 'vr-sticky-atc-bar';

    var overlay = document.createElement('div');
    overlay.className = 'vr-sticky-overlay';
    overlay.addEventListener('click', function() { closeDropdown(state, bar); });

    var inner = document.createElement('div');
    inner.className = 'vr-sticky-inner';

    // Top row: thumbnail + variant dropdown + price
    var topRow = document.createElement('div');
    topRow.className = 'vr-sticky-top-row';

    // Small thumbnail of selected variant
    var thumb = document.createElement('img');
    thumb.className = 'vr-sticky-thumb';
    thumb.alt = '';
    thumb.loading = 'lazy';
    if (state.selectedVariant.image) {
      thumb.src = resizeImage(state.selectedVariant.image, 80);
    }

    var variantWrap = document.createElement('div');
    variantWrap.className = 'vr-sticky-variant-wrap';

    // When the product has no real variants hide the dropdown entirely
    var isSingleVariant = sortedVariants.length <= 1 || sortedVariants.every(function(v) { return v._isSingleVariant; });

    var variantBtn = document.createElement('button');
    variantBtn.type = 'button';
    variantBtn.className = 'vr-sticky-variant-btn';
    variantBtn.innerHTML = '<span class="vr-sticky-variant-label">' + escapeHtml(cleanVariantName(state.selectedVariant.public_title || state.selectedVariant.title)) + '</span>' +
      (isSingleVariant ? '' : '<span class="vr-sticky-variant-arrow"></span>');

    if (isSingleVariant) {
      variantBtn.style.cursor = 'default';
      variantBtn.style.pointerEvents = 'none';
    } else {
      variantBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        if (state.isDropdownOpen) {
          closeDropdown(state, bar);
        } else {
          openDropdown(state, bar);
        }
      });
    }

    var dropdown = document.createElement('div');
    dropdown.className = 'vr-sticky-dropdown';
    populateDropdown(dropdown, sortedVariants, state, bar);

    variantWrap.appendChild(variantBtn);
    variantWrap.appendChild(dropdown);

    var priceEl = document.createElement('div');
    priceEl.className = 'vr-sticky-price';
    priceEl.innerHTML = formatPriceHtml(state.selectedVariant);

    topRow.appendChild(thumb);
    topRow.appendChild(variantWrap);
    topRow.appendChild(priceEl);

    // Bottom row: quantity + ATC
    var bottomRow = document.createElement('div');
    bottomRow.className = 'vr-sticky-bottom-row';

    var qtyWrap = document.createElement('div');
    qtyWrap.className = 'vr-sticky-qty';

    var qtyMinus = document.createElement('button');
    qtyMinus.type = 'button';
    qtyMinus.className = 'vr-sticky-qty-btn';
    qtyMinus.textContent = '\u2212';
    qtyMinus.disabled = state.quantity <= 1;
    qtyMinus.addEventListener('click', function() {
      if (state.quantity > 1) {
        state.quantity--;
        updateQuantityDisplay(state, bar);
      }
    });

    var qtyVal = document.createElement('span');
    qtyVal.className = 'vr-sticky-qty-val';
    qtyVal.textContent = state.quantity;

    var qtyPlus = document.createElement('button');
    qtyPlus.type = 'button';
    qtyPlus.className = 'vr-sticky-qty-btn';
    qtyPlus.textContent = '+';
    qtyPlus.addEventListener('click', function() {
      var maxQty = getMaxQuantity(state.selectedVariant, state);
      if (maxQty !== null && state.quantity >= maxQty) {
        updateQuantityDisplay(state, bar);
        return;
      }
      state.quantity++;
      updateQuantityDisplay(state, bar);
    });

    qtyWrap.appendChild(qtyMinus);
    qtyWrap.appendChild(qtyVal);
    qtyWrap.appendChild(qtyPlus);

    var atcBtn = document.createElement('button');
    atcBtn.type = 'button';
    atcBtn.className = 'vr-sticky-atc-btn';
    if (!state.selectedVariant.available) {
      atcBtn.className += ' is-soldout';
      atcBtn.textContent = 'Sold Out';
      atcBtn.disabled = true;
    } else {
      atcBtn.textContent = 'Add to Cart';
    }
    atcBtn.addEventListener('click', function() {
      if (state.isAdding || !state.selectedVariant.available) return;
      addToCart(state, bar);
    });

    bottomRow.appendChild(qtyWrap);
    bottomRow.appendChild(atcBtn);

    var qtyWarn = document.createElement('div');
    qtyWarn.className = 'vr-sticky-qty-warn';

    var inCart = document.createElement('div');
    inCart.className = 'vr-sticky-in-cart';

    var allInCart = document.createElement('div');
    allInCart.className = 'vr-sticky-all-in-cart';

    inner.appendChild(topRow);
    inner.appendChild(inCart);
    inner.appendChild(bottomRow);
    inner.appendChild(qtyWarn);
    inner.appendChild(allInCart);
    bar.appendChild(overlay);
    bar.appendChild(inner);

    return bar;
  }

  function populateDropdown(dropdown, sortedVariants, state, bar) {
    dropdown.innerHTML = '';

    var hasAvailable = sortedVariants.some(function(v) { return v.available; });
    var hasSoldOut = sortedVariants.some(function(v) { return !v.available; });
    var addedSep = false;

    sortedVariants.forEach(function(variant) {
      if (!variant.available && !addedSep && hasAvailable && hasSoldOut) {
        var sep = document.createElement('div');
        sep.className = 'vr-sticky-soldout-sep';
        sep.textContent = 'Sold Out';
        dropdown.appendChild(sep);
        addedSep = true;
      }

      var item = document.createElement('div');
      item.className = 'vr-sticky-dropdown-item';
      if (!variant.available) item.className += ' is-soldout';
      if (variant.id === state.selectedVariant.id) item.className += ' is-selected';

      // Variant image thumbnail
      if (variant.image) {
        var img = document.createElement('img');
        img.className = 'vr-dd-img';
        img.src = resizeImage(variant.image, 84);
        img.alt = '';
        img.loading = 'lazy';
        item.appendChild(img);
      }

      // Info column: name + price/stock row
      var infoDiv = document.createElement('div');
      infoDiv.className = 'vr-dd-info';

      var nameSpan = document.createElement('span');
      nameSpan.className = 'vr-dd-name';
      nameSpan.textContent = cleanVariantName(variant.public_title || variant.title);
      infoDiv.appendChild(nameSpan);

      var metaDiv = document.createElement('div');
      metaDiv.className = 'vr-dd-meta';

      var priceSpan = document.createElement('span');
      priceSpan.className = 'vr-dd-price';
      priceSpan.innerHTML = formatPriceHtml(variant);
      metaDiv.appendChild(priceSpan);

      // Inventory badge (pass all variants for relative thresholds)
      var invInfo = getInventoryInfo(variant, sortedVariants);
      if (invInfo) {
        var stockSpan = document.createElement('span');
        stockSpan.className = 'vr-dd-stock tier-' + invInfo.tier;
        stockSpan.innerHTML = '<span class="vr-dd-stock-dot"></span>' + escapeHtml(invInfo.text);
        metaDiv.appendChild(stockSpan);
      }

      infoDiv.appendChild(metaDiv);
      item.appendChild(infoDiv);

      if (!variant.available) {
        var badge = document.createElement('span');
        badge.className = 'vr-dd-soldout-badge';
        badge.textContent = 'Sold Out';
        item.appendChild(badge);
      }

      if (variant.available) {
        item.addEventListener('click', function() {
          selectVariant(variant, state, bar, sortedVariants);
        });
      }

      dropdown.appendChild(item);
    });
  
    // Re-insert box banner if dropdown was rebuilt
    if (typeof mmBoxBannerMode !== "undefined" && mmBoxBannerMode) { try { mmEnsureMobileBoxBanner(); } catch(e) {} }
  }

  // ── Actions ───────────────────────────────────────────────────────────

  function updatePriceDisplay(bar, variant) {
    var priceEl = bar.querySelector('.vr-sticky-price');
    if (priceEl) priceEl.innerHTML = formatPriceHtml(variant);
  }

  function getMaxQuantity(variant, state) {
    if (typeof variant.inventory_quantity === 'number' && variant.inventory_quantity > 0) {
      var inCart = (state && typeof state.inCartQty === 'number') ? state.inCartQty : 0;
      var remaining = variant.inventory_quantity - inCart;
      return remaining > 0 ? remaining : 0;
    }
    return null;
  }

  function selectVariant(variant, state, bar, sortedVariants) {
    trackEvent('sticky-atc-variant-selected', {
      variant_id: String(variant.id),
      variant_title: variant.public_title || variant.title,
      variant_price: variant.price
    });
    state.selectedVariant = variant;
    state.quantity = 1;

    var labelEl = bar.querySelector('.vr-sticky-variant-label');
    if (labelEl) labelEl.textContent = cleanVariantName(variant.public_title || variant.title);

    updatePriceDisplay(bar, variant);

    // Update the bar thumbnail
    var thumb = bar.querySelector('.vr-sticky-thumb');
    if (thumb && variant.image) {
      thumb.src = resizeImage(variant.image, 80);
    }

    var atcBtn = bar.querySelector('.vr-sticky-atc-btn');
    if (atcBtn) {
      atcBtn.classList.remove('is-soldout', 'is-success');
      atcBtn.disabled = false;
      atcBtn.textContent = 'Add to Cart';
      if (!variant.available) {
        atcBtn.classList.add('is-soldout');
        atcBtn.textContent = 'Sold Out';
        atcBtn.disabled = true;
      }
    }

    updateQuantityDisplay(state, bar);

    var dropdown = bar.querySelector('.vr-sticky-dropdown');
    if (dropdown) populateDropdown(dropdown, sortedVariants, state, bar);

    updateInCartIndicator(state, bar);

    closeDropdown(state, bar);
    syncPageVariant(variant);
  }

  function syncPageVariant(variant) {
    try {
      var title = variant.public_title || variant.title;
      var mainPicker = document.querySelector('variant-picker.product-form__variants[form-id*="product-form-main"]');
      if (!mainPicker) return;

      var labels = mainPicker.querySelectorAll('.block-swatch__item');
      labels.forEach(function(label) {
        if (label.getAttribute('title') === title) {
          var radioId = label.getAttribute('for');
          if (radioId) {
            var radio = document.getElementById(radioId);
            if (radio && !radio.checked) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      });

      try {
        var swatchItems = document.querySelectorAll('.swatch-selector[data-value="' + (title).replace(/"/g, '\\"') + '"]');
        swatchItems.forEach(function(swatch) {
          if (!swatch.classList.contains('swatch-selected')) {
            swatch.click();
          }
        });
      } catch(e) {}
    } catch(e) {}
  }

  function getProductId() {
    // Primary: use the ID captured from the product.js fetch (works on every product)
    if (_resolvedProductId) return _resolvedProductId;

    try {
      var saId = window.ShopifyAnalytics && window.ShopifyAnalytics.meta &&
                 window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.id;
      if (saId) return String(saId);
    } catch(e) {}
    return null;
  }

  function fetchCartQtyForVariant(variantId, cb) {
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = rootUrl + 'cart.js';
    fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function(r) {
        if (!r.ok) { console.warn('[sticky-atc] cart.js fetch status', r.status); return null; }
        return r.json();
      })
      .then(function(cart) {
        if (!cart) { cb(0); return; }
        var n = 0;
        if (cart.items && cart.items.length) {
          for (var i = 0; i < cart.items.length; i++) {
            if (String(cart.items[i].variant_id) === String(variantId)) {
              n += (cart.items[i].quantity || 0);
            }
          }
        }
        cb(n);
      })
      .catch(function(e) { console.warn('[sticky-atc] cart.js fetch failed', e); cb(0); });
  }

  function updateInCartIndicator(state, bar) {
    var el = bar.querySelector('.vr-sticky-in-cart');
    if (!el) { console.warn('[sticky-atc] no .vr-sticky-in-cart element in bar'); return; }
    if (!state.selectedVariant) { console.warn('[sticky-atc] no selected variant'); return; }
    fetchCartQtyForVariant(state.selectedVariant.id, function(n) {
      state.inCartQty = n;
      if (n > 0) {
        el.innerHTML = '<strong>' + n + '</strong> in your cart';
        el.classList.add('is-visible');
      } else {
        el.classList.remove('is-visible');
      }
      // Clamp qty to new remaining so the selector reflects reality
      var remaining = getMaxQuantity(state.selectedVariant, state);
      if (remaining !== null && state.quantity > remaining) {
        state.quantity = Math.max(1, remaining);
      }
      applyMaxInCartState(state, bar);
      updateQuantityDisplay(state, bar);
    });
  }

  function applyMaxInCartState(state, bar) {
    var atcBtn = bar.querySelector('.vr-sticky-atc-btn');
    if (!atcBtn || !state.selectedVariant) return;
    var invRaw = state.selectedVariant.inventory_quantity;
    var inv = (typeof invRaw === 'number' && invRaw >= 0) ? invRaw : null;
    var inCart = state.inCartQty || 0;
    var allInCartEl = bar.querySelector('.vr-sticky-all-in-cart');
    if (!state.selectedVariant.available) return; // sold out path already handled
    if (inv !== null && inCart > 0 && inCart >= inv) {
      atcBtn.classList.add('is-maxed');
      atcBtn.disabled = true;
      atcBtn.textContent = 'Already in cart';
      if (allInCartEl) {
        allInCartEl.textContent = 'All ' + inv + ' available already in cart';
        allInCartEl.classList.add('is-visible');
      }
      // Hide the "X in your cart" line when the all-maxed line takes over
      var incEl = bar.querySelector('.vr-sticky-in-cart');
      if (incEl) incEl.classList.remove('is-visible');
    } else {
      atcBtn.classList.remove('is-maxed');
      atcBtn.disabled = false;
      if (atcBtn.textContent === 'Already in cart') atcBtn.textContent = 'Add to Cart';
      if (allInCartEl) allInCartEl.classList.remove('is-visible');
    }
  }

  function openAnyCartDrawer() {
    try {
      // Strategy 1 — click an inner child of the header cart icon (span/div,
      // not the anchor itself). The click bubbles up to the anchor; whatever
      // drawer app is installed (Incredible Cart on live) preventDefaults
      // navigation and opens its drawer. Most reliable, uses active app.
      var iconChild = document.querySelector(
        'a[href*="/cart"] .icon--cart, a[href*="/cart"] .header__cart-count, ' +
        'a[href*="/cart"] .icon-state__primary, .header__cart > span, .header__cart > svg'
      );
      if (iconChild) { iconChild.click(); return true; }

      // Strategy 2 — Incredible Cart direct manipulation
      var ia = document.querySelector('.ia-sliding-cart');
      if (ia) {
        ia.classList.remove('ia-sliding-cart--inactive');
        var iaOv = document.querySelector('.ia-cart-overlay');
        if (iaOv) { try { iaOv.style.display = 'block'; } catch(e) {} }
        return true;
      }
      // Strategy 3 — native <cart-drawer>
      var native = document.querySelector('cart-drawer');
      if (native) { native.setAttribute('open', ''); return true; }
      // Strategy 4 — last-resort header cart anchor (may navigate if no app)
      var header = document.querySelector('a[href="/cart"], a[href$="/cart"]');
      if (header) { header.click(); return true; }
    } catch(e) {}
    return false;
  }

  function humanizeStockMessage(desc, state) {
    var name = state.selectedVariant.public_title || state.selectedVariant.title || 'this item';
    if (desc && /all\s+\d+\s+are\s+in\s+your\s+cart/i.test(desc)) {
      var m = desc.match(/all\s+(\d+)/i);
      var max = m ? m[1] : '';
      return 'You already have ' + (max ? 'all ' + max + ' ' : 'the max of ') + name + ' in your cart.';
    }
    if (desc && /only\s+add\s+(\d+)/i.test(desc)) {
      var m2 = desc.match(/only\s+add\s+(\d+)/i);
      return 'Only ' + m2[1] + ' of ' + name + ' left \u2014 check your cart.';
    }
    if (desc) return desc;
    return 'You\u2019ve reached the stock limit for ' + name + '. Check your cart.';
  }

  function handleStockLimit(shopifyDesc, state, bar, atcBtn) {
    atcBtn.classList.remove('is-loading');
    state.isAdding = false;

    var niceMsg = humanizeStockMessage(shopifyDesc, state);

    atcBtn.style.background = '#ff7a1a';
    atcBtn.style.color = '#fff';
    atcBtn.textContent = 'Check your cart';

    var warn = bar.querySelector('.vr-sticky-qty-warn');
    if (warn) {
      warn.textContent = niceMsg;
      warn.classList.add('is-visible');
    }

    setTimeout(function() { openAnyCartDrawer(); }, 1200);

    setTimeout(function() {
      atcBtn.style.background = '';
      atcBtn.style.color = '';
      if (state.selectedVariant.available) atcBtn.textContent = 'Add to Cart';
      updateQuantityDisplay(state, bar);
    }, 4000);
  }

  function handleGenericFailure(shopifyDesc, state, bar, atcBtn) {
    atcBtn.classList.remove('is-loading');
    state.isAdding = false;

    atcBtn.style.background = '#ff4444';
    atcBtn.style.color = '#fff';
    atcBtn.textContent = 'Please try again';

    var warn = bar.querySelector('.vr-sticky-qty-warn');
    if (warn) {
      warn.textContent = shopifyDesc || 'Something interrupted checkout. Please try again.';
      warn.classList.add('is-visible');
    }

    setTimeout(function() {
      atcBtn.style.background = '';
      atcBtn.style.color = '';
      if (state.selectedVariant.available) atcBtn.textContent = 'Add to Cart';
      updateQuantityDisplay(state, bar);
    }, 3500);
  }

  function addToCart(state, bar) {
    if (state.isAdding || !state.selectedVariant.available) return;

    trackEvent('sticky-atc-click', {
      variant_id: String(state.selectedVariant.id),
      variant_title: state.selectedVariant.public_title || state.selectedVariant.title,
      quantity: state.quantity,
      variant_price: state.selectedVariant.price
    });

    state.isAdding = true;
    var atcBtn = bar.querySelector('.vr-sticky-atc-btn');
    if (!atcBtn) return;

    atcBtn.classList.add('is-loading');
    atcBtn.innerHTML = '<span class="vr-sticky-spinner"></span> Adding...';

    var sections = [];
    var cartDrawerSection = document.querySelector('[id*="cart-drawer"].shopify-section');
    if (cartDrawerSection) sections.push(cartDrawerSection.id.replace('shopify-section-', ''));
    var headerSection = document.querySelector('[id*="header"].shopify-section');
    if (headerSection) sections.push(headerSection.id.replace('shopify-section-', ''));

    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    var body = {
      items: [{ id: parseInt(state.selectedVariant.id, 10), quantity: state.quantity }]
    };
    if (sections.length > 0) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function(response) { return response.json().then(function(data) { return { ok: response.ok, status: response.status, data: data }; }); })
    .then(function(result) {
      var isStockIssue = !result.ok && (result.status === 422 || result.data.status === 422);
      var shopifyDesc = result.data && (result.data.description || result.data.message);

      if (isStockIssue) {
        handleStockLimit(shopifyDesc, state, bar, atcBtn);
        return;
      }

      if (!result.ok || result.data.status) {
        handleGenericFailure(shopifyDesc, state, bar, atcBtn);
        return;
      }

      if (result.data.sections) {
        Object.entries(result.data.sections).forEach(function(entry) {
          var sectionId = entry[0];
          var html = entry[1];
          if (html === null || html === undefined) return;
          var el = document.getElementById('shopify-section-' + sectionId);
          if (el) {
            el.outerHTML = html;
            document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: sectionId } }));
          }
        });
      }

      trackEvent('sticky-atc-success', {
        variant_id: String(state.selectedVariant.id),
        variant_title: state.selectedVariant.public_title || state.selectedVariant.title,
        quantity: state.quantity,
        variant_price: state.selectedVariant.price
      });

      var prodId = getProductId();
      if (prodId) {
        trackEvent('product-clicked-attribution', { product_id: prodId });
      }

      atcBtn.classList.remove('is-loading');
      atcBtn.classList.add('is-success');
      atcBtn.innerHTML = '&#10003; Added!';

      setTimeout(function() {
        try {
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) cartDrawer.setAttribute('open', '');
        } catch(e) {}
      }, 80);

      setTimeout(function() {
        atcBtn.classList.remove('is-success');
        atcBtn.textContent = 'Add to Cart';
        state.isAdding = false;
      }, 2000);
    })
    .catch(function(err) {
      atcBtn.classList.remove('is-loading');
      state.isAdding = false;

      var isNetwork = err && (err.name === 'AbortError' || err.name === 'TypeError');
      var btnLabel = isNetwork ? 'Connection issue \u2014 retry' : 'Please try again';
      var warnMsg = isNetwork
        ? 'Network hiccup. Please try again.'
        : 'Something interrupted checkout. Please try again.';

      atcBtn.style.background = '#ff4444';
      atcBtn.style.color = '#fff';
      atcBtn.textContent = btnLabel;

      var warn = bar.querySelector('.vr-sticky-qty-warn');
      if (warn) {
        warn.textContent = warnMsg;
        warn.classList.add('is-visible');
      }

      setTimeout(function() {
        atcBtn.style.background = '';
        atcBtn.style.color = '';
        if (state.selectedVariant.available) {
          atcBtn.textContent = 'Add to Cart';
        }
        updateQuantityDisplay(state, bar);
      }, 3500);
    });
  }

  function openDropdown(state, bar) {
    state.isDropdownOpen = true;
    trackEvent('sticky-atc-dropdown-open', {
      current_variant: state.selectedVariant.public_title || state.selectedVariant.title
    });
    var dd = bar.querySelector('.vr-sticky-dropdown');
    var arrow = bar.querySelector('.vr-sticky-variant-arrow');
    var overlay = bar.querySelector('.vr-sticky-overlay');
    if (dd) dd.classList.add('is-open');
    if (arrow) arrow.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');

    setTimeout(function() {
      var selected = dd && dd.querySelector('.is-selected');
      if (selected) selected.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }, 50);
  }

  function closeDropdown(state, bar) {
    state.isDropdownOpen = false;
    var dd = bar.querySelector('.vr-sticky-dropdown');
    var arrow = bar.querySelector('.vr-sticky-variant-arrow');
    var overlay = bar.querySelector('.vr-sticky-overlay');
    if (dd) dd.classList.remove('is-open');
    if (arrow) arrow.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
  }

  function updateQuantityDisplay(state, bar) {
    var qtyVal = bar.querySelector('.vr-sticky-qty-val');
    if (qtyVal) qtyVal.textContent = state.quantity;

    var btns = bar.querySelectorAll('.vr-sticky-qty .vr-sticky-qty-btn');
    var minusBtn = btns[0];
    var plusBtn = btns[1];

    if (minusBtn) minusBtn.disabled = state.quantity <= 1;

    var maxQty = getMaxQuantity(state.selectedVariant, state);
    var atMax = maxQty !== null && state.quantity >= maxQty;

    if (plusBtn) plusBtn.disabled = atMax;

    // Show / hide the stock-limit warning
    var warn = bar.querySelector('.vr-sticky-qty-warn');
    if (warn) {
      if (atMax && maxQty > 0) {
        warn.textContent = 'Only ' + maxQty + ' more available';
        warn.classList.add('is-visible');
      } else {
        warn.classList.remove('is-visible');
      }
    }
  }

  // ── Cart drawer watcher ───────────────────────────────────────────────
  // Hide the sticky ATC bar instantly whenever any cart drawer is open.
  // Targets: Incredible Cart (ia-sliding-cart / ia-cart-overlay),
  // native Shopify cart drawers, and generic patterns.

  function setupCartDrawerWatcher(state, bar) {
    // Only hide the sticky bar when the user explicitly clicks the header
    // cart icon. When the cart drawer later closes, re-show the bar.

    function hideBar() {
      bar.classList.add('vr-cart-open');
      bar.classList.remove('is-visible');
      state.isVisible = false;
    }

    function showBarIfNeeded() {
      bar.classList.remove('vr-cart-open');
      if (state._scrollCheck) state._scrollCheck();
    }

    function isCartDrawerOpen() {
      var iaCart = document.querySelector('.ia-sliding-cart');
      if (iaCart && !iaCart.classList.contains('ia-sliding-cart--inactive')) return true;
      var iaOverlay = document.querySelector('.ia-cart-overlay');
      if (iaOverlay) {
        try {
          var s = window.getComputedStyle(iaOverlay);
          if (s.display !== 'none') return true;
        } catch(e) {}
      }
      return false;
    }

    // When user clicks the header cart icon, hide the sticky bar
    document.addEventListener('click', function(e) {
      var cartIcon = e.target.closest(
        '.header__cart, a[href*="/cart"] .icon--cart, a[href*="/cart"] .header__cart-count, ' +
        'a[href*="/cart"] .icon-state__primary'
      );
      if (!cartIcon) {
        // Also match the link itself if it wraps the cart icon
        var link = e.target.closest('a[href*="/cart"]');
        if (link && link.querySelector('.icon--cart')) cartIcon = link;
      }
      if (cartIcon) {
        setTimeout(hideBar, 50);
      }
    }, true);

    // Watch for cart drawer closing so we can re-show the bar
    function watchForClose() {
      var iaCart = document.querySelector('.ia-sliding-cart');
      if (iaCart) {
        try {
          var mo = new MutationObserver(function() {
            if (iaCart.classList.contains('ia-sliding-cart--inactive')) {
              showBarIfNeeded();
            }
          });
          mo.observe(iaCart, { attributes: true, attributeFilter: ['class'] });
        } catch(e) {}
        return true;
      }
      return false;
    }

    function watchOverlayClose() {
      var overlay = document.querySelector('.ia-cart-overlay');
      if (overlay) {
        try {
          var mo = new MutationObserver(function() {
            var s = window.getComputedStyle(overlay);
            if (s.display === 'none') {
              showBarIfNeeded();
            }
          });
          mo.observe(overlay, { attributes: true, attributeFilter: ['style'] });
        } catch(e) {}
        return true;
      }
      return false;
    }

    // Also listen for cart close button clicks inside the drawer
    document.addEventListener('click', function(e) {
      var closeBtn = e.target.closest('.ia-title-bar-close-button');
      if (closeBtn) {
        setTimeout(function() {
          if (!isCartDrawerOpen()) showBarIfNeeded();
        }, 300);
      }
    }, true);

    // Also listen for overlay clicks (clicking outside the cart to close it)
    document.addEventListener('click', function(e) {
      if (e.target.classList && e.target.classList.contains('ia-cart-overlay')) {
        setTimeout(function() {
          if (!isCartDrawerOpen()) showBarIfNeeded();
        }, 300);
      }
    }, true);

    var foundCart = watchForClose();
    var foundOverlay = watchOverlayClose();
    if (!foundCart || !foundOverlay) {
      var findInterval = setInterval(function() {
        if (!foundCart) foundCart = watchForClose();
        if (!foundOverlay) foundOverlay = watchOverlayClose();
        if (foundCart && foundOverlay) clearInterval(findInterval);
      }, 500);
      setTimeout(function() { clearInterval(findInterval); }, 20000);
    }
  }

  // ── Scroll logic ──────────────────────────────────────────────────────

  function hideCompetingElements(show) {
    var selectors = [
      '#gigit-sticky-add-to-cart',
      '#PAFloaterContainer',
      '#smile-ui-container'
    ];
    selectors.forEach(function(sel) {
      try {
        var el = document.querySelector(sel);
        if (el) el.style.display = show ? 'none' : '';
      } catch(e) {}
    });
  }

  function setupScrollListener(state, bar) {
    var hasTrackedImpression = false;
    // Gate: the bar must never appear until the user has actually scrolled
    // down from the very top of the page. This prevents the bar from
    // flashing on initial page load even if the ATC block is off-screen.
    var userHasScrolledDown = false;

    function show() {
      if (!userHasScrolledDown) return;
      if (bar.classList.contains('vr-cart-open')) return;
      if (!state.isVisible) {
        state.isVisible = true;
        bar.classList.add('is-visible');
        hideCompetingElements(true);
        if (!hasTrackedImpression) {
          hasTrackedImpression = true;
          trackEvent('sticky-atc-impression', {});
        }
      }
    }
    function hide() {
      if (state.isVisible) {
        state.isVisible = false;
        bar.classList.remove('is-visible');
        hideCompetingElements(false);
        closeDropdown(state, bar);
      }
    }

    if (typeof IntersectionObserver === 'undefined') return;

    var isMobile = window.innerWidth < 768;

    // ── Find anchor elements ──
    var atcBlock = document.querySelector('.product-info__block-item--buy-buttons[data-block-id="buy_buttons"]')
      || document.querySelector('.product-form__buy-buttons')
      || document.querySelector('[data-action="add-to-cart"]');

    var swatchList = document.querySelector('ul.swatch-view')
      || document.querySelector('.block-swatch-list')
      || document.querySelector('variant-picker.product-form__variants');

    var triggered = { swatch: false, atc: false, scroll: false };

    function check() {
      if (triggered.swatch || triggered.atc || triggered.scroll) {
        show();
      } else {
        hide();
      }
    }
    // Expose so the cart-drawer watcher can re-trigger visibility after cart closes
    state._scrollCheck = check;

    // ── Scroll gate: require at least 100px of downward scroll before
    //    the sticky bar is allowed to appear. Once the user scrolls back
    //    to the top (within 50px), lock the gate again. ──
    var scrollEl = document.scrollingElement || document.documentElement;
    function onScroll() {
      var y = scrollEl.scrollTop || window.pageYOffset || 0;
      if (!userHasScrolledDown && y > 100) {
        userHasScrolledDown = true;
        check();
      } else if (userHasScrolledDown && y <= 50) {
        userHasScrolledDown = false;
        hide();
      }
      // Additional trigger: show bar once user has scrolled a bit even if
      // buy buttons are still visible at top of viewport.
      var shouldShowOnScroll = y > 250;
      if (triggered.scroll !== shouldShowOnScroll) {
        triggered.scroll = shouldShowOnScroll;
        check();
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // ── Primary: ATC button fully off-screen → show; any part back → hide ──
    if (atcBlock) {
      var atcObs = new IntersectionObserver(function(entries) {
        triggered.atc = !entries[0].isIntersecting;
        check();
      }, { threshold: 0 });
      atcObs.observe(atcBlock);
    }

    // ── Mobile only: also trigger when most of the swatches have
    //    been scrolled past (so the bar can appear a touch earlier) ──
    if (isMobile && swatchList) {
      var swatchObs = new IntersectionObserver(function(entries) {
        triggered.swatch = !entries[0].isIntersecting;
        check();
      }, { threshold: 0, rootMargin: '0px 0px -70% 0px' });
      swatchObs.observe(swatchList);
    }
  }

  // ── Page sync ─────────────────────────────────────────────────────────

  function setupPageSyncListener(state, sortedVariants, bar) {
    function syncVariantToBar(title) {
      var matchedVariant = sortedVariants.find(function(v) {
        return v.public_title === title || v.title === title;
      });
      if (matchedVariant && matchedVariant.id !== state.selectedVariant.id) {
        state.selectedVariant = matchedVariant;
        state.quantity = 1;

        var labelEl = bar.querySelector('.vr-sticky-variant-label');
        if (labelEl) labelEl.textContent = cleanVariantName(matchedVariant.public_title || matchedVariant.title);

        updatePriceDisplay(bar, matchedVariant);

        var thumb = bar.querySelector('.vr-sticky-thumb');
        if (thumb && matchedVariant.image) {
          thumb.src = resizeImage(matchedVariant.image, 80);
        }

        var atcBtn = bar.querySelector('.vr-sticky-atc-btn');
        if (atcBtn) {
          atcBtn.classList.remove('is-soldout', 'is-success');
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to Cart';
          if (!matchedVariant.available) {
            atcBtn.classList.add('is-soldout');
            atcBtn.textContent = 'Sold Out';
            atcBtn.disabled = true;
          }
        }

        updateQuantityDisplay(state, bar);
        var dropdown = bar.querySelector('.vr-sticky-dropdown');
        if (dropdown) populateDropdown(dropdown, sortedVariants, state, bar);

        updateInCartIndicator(state, bar);
      }
    }

    try {
      // Listen to native variant picker radios
      var mainPicker = document.querySelector('variant-picker.product-form__variants[form-id*="product-form-main"]');
      if (mainPicker) {
        mainPicker.addEventListener('change', function(e) {
          if (!e.target || !e.target.classList.contains('block-swatch__radio')) return;
          var label = e.target.nextElementSibling;
          if (!label) return;
          syncVariantToBar(label.getAttribute('title') || label.textContent.trim());
        });
      }

      // Listen to swatch app clicks (these replace the native picker on this theme)
      document.addEventListener('click', function(e) {
        var swatchEl = e.target.closest('.swatch-selector[data-value]');
        if (!swatchEl) return;
        var title = swatchEl.getAttribute('data-value');
        if (title) {
          setTimeout(function() { syncVariantToBar(title); }, 50);
        }
      });

      // Quantity input sync
      var qtyInput = document.querySelector('quantity-picker.quantity-selector--product .quantity-selector__value');
      if (qtyInput) {
        var qtyObserver = new MutationObserver(function() {
          var newQty = parseInt(qtyInput.value, 10);
          if (newQty && newQty !== state.quantity) {
            state.quantity = newQty;
            updateQuantityDisplay(state, bar);
          }
        });
        qtyObserver.observe(qtyInput, { attributes: true, attributeFilter: ['value'] });

        qtyInput.addEventListener('change', function() {
          var newQty = parseInt(qtyInput.value, 10);
          if (newQty && newQty !== state.quantity) {
            state.quantity = newQty;
            updateQuantityDisplay(state, bar);
          }
        });
      }
    } catch(e) {}
  }

  // ── Utilities ─────────────────────────────────────────────────────────

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /**
   * Strip *NEW* / *New* tags from variant display names since we show
   * them as visual badges instead.
   */
  function cleanVariantName(name) {
    return (name || '')
      .replace(/\s*\*NEW\*\s*/gi, '')
      .replace(/\s*NEW!\s*/gi, '')
      .trim();
  }

  // ── Boot ──────────────────────────────────────────────────────────────


  // ── Box product banner (mobile) ─────────────────────────────────────
  function mmIsBoxProduct() {
    try {
      var handle = '';
      var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
      if (match) handle = match[1];
      var ogTitle = document.querySelector('meta[property="og:title"]');
      var title = (ogTitle && ogTitle.getAttribute('content')) || document.title || '';
      var combined = (title + ' ' + handle).toLowerCase();
      return /\b(?:1\s+)?(?:box|case)\s+of\s+\d+\b/.test(combined) ||
             /-box-of-\d+/.test(handle) ||
             /-case-of-\d+/.test(handle);
    } catch(e) { return false; }
  }

  function mmGetProductVendor() {
    try {
      if (window.productVendor) return window.productVendor;
      if (window.meta && window.meta.product && window.meta.product.vendor) return window.meta.product.vendor;
      var m = document.querySelector('meta[property="product:brand"]');
      if (m) return m.getAttribute('content');
    } catch(e) {}
    return '';
  }

  function mmFindSinglesUrl() {
    var vendor = mmGetProductVendor() || '';
    var title = '';
    try {
      var og = document.querySelector('meta[property="og:title"]');
      title = (og && og.getAttribute('content')) || '';
      title = title.replace(/[|\u2013\u2014].*$/, '').trim();
    } catch(e) {}
    title = title.replace(/\s*[\(\[]?\s*(?:1\s*)?(?:box|case|Box|Case|BOX|CASE)\s+of\s+\d+[^\)\]]*[\)\]]?\s*$/i, '').trim();
    var vendorSlug = vendor ? vendor.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') : '';
    var fallbackUrl = vendorSlug ? '/collections/' + vendorSlug : '/collections/individual-protein-snacks';
    var query = encodeURIComponent(((vendor + ' ' + title).trim() + ' 1 bar').substring(0, 120));
    return fetch('/search/suggest.json?q=' + query + '&resources[type]=product&resources[limit]=10')
      .then(function(r) { return r.ok ? r.json() : null; })
      .catch(function() { return null; })
      .then(function(data) {
        if (!data) return fallbackUrl;
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        var singlePatterns = /\b(?:1|one)\s*(?:bar|unit|piece|pc|can|serving|cookie|muffin|donut|brownie|pretzel|cup|sachet|pack|bag|pie|bite|mallow|treat)\b/i;
        for (var i = 0; i < products.length; i++) {
          var t = products[i].title || '';
          if (singlePatterns.test(t) && !/(box|case)\s+of/i.test(t)) {
            return products[i].url || ('/products/' + products[i].handle);
          }
        }
        return fallbackUrl;
      });
  }

  function mmCreateMobileBanner() {
    var banner = document.createElement('div');
    banner.className = 'vr-mm-dropdown-banner';
    banner.style.cssText = [
      'padding: 8px 12px',
      'background: linear-gradient(135deg, #fef8d6 0%, #fefcf0 100%)',
      'border-bottom: 1px solid rgba(252, 221, 0, 0.35)',
      'font-family: inherit',
      'font-size: 12px',
      'line-height: 1.35',
      'color: #1e2d7d',
      'position: sticky',
      'top: 0',
      'z-index: 2',
      'display: flex',
      'align-items: flex-start'
    ].join(';');
    return banner;
  }

  function mmBuildBoxBannerContent(banner, singlesUrl) {
    banner.innerHTML = '';
    if (singlesUrl) {
      banner.style.cursor = 'pointer';
      banner.setAttribute('data-singles-url', singlesUrl);
      banner.onclick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = singlesUrl;
      };
    }
    var tagIcon = document.createElement('span');
    tagIcon.style.cssText = 'margin-right: 4px;';
    tagIcon.textContent = '\uD83D\uDCE6';

    var msg = document.createElement('span');
    msg.appendChild(document.createTextNode('Build your own box: any 12 singles under $6 \u2014 use code '));

    var codeEl = document.createElement('span');
    codeEl.style.cssText = 'font-weight:700;background:rgba(252,221,0,0.35);padding:1px 5px;border-radius:3px;color:#1e2d7d;letter-spacing:0.3px;';
    codeEl.textContent = 'FREESNACK2';
    msg.appendChild(codeEl);
    msg.appendChild(document.createTextNode(' for 2 FREE'));

    banner.appendChild(tagIcon);
    banner.appendChild(msg);
  }

  var mmBoxBannerMode = false;
  var mmBoxBannerSinglesUrl = null;

  function mmEnsureMobileBoxBanner() {
    if (!mmBoxBannerMode) return;
    var bar = document.getElementById('vr-sticky-atc-bar');
    if (!bar) return;
    var dropdown = bar.querySelector('.vr-sticky-dropdown');
    if (!dropdown) return;
    var existing = dropdown.querySelector('.vr-mm-dropdown-banner');
    if (existing) {
      mmBuildBoxBannerContent(existing, mmBoxBannerSinglesUrl);
      return;
    }
    var banner = mmCreateMobileBanner();
    mmBuildBoxBannerContent(banner, mmBoxBannerSinglesUrl);
    dropdown.insertBefore(banner, dropdown.firstChild);
  }

  function mmInitMobileBoxBanner() {
    if (mmBoxBannerMode) return;
    if (!mmIsBoxProduct()) return;
    mmBoxBannerMode = true;
    mmFindSinglesUrl().then(function(url) {
      mmBoxBannerSinglesUrl = url;
      var retries = 0;
      var maxRetries = 60;
      var timer = setInterval(function() {
        retries++;
        var bar = document.getElementById('vr-sticky-atc-bar');
        if (!bar) { if (retries > maxRetries) clearInterval(timer); return; }
        clearInterval(timer);
        mmEnsureMobileBoxBanner();
        var variantBtn = bar.querySelector('.vr-sticky-variant-btn');
        if (variantBtn) {
          variantBtn.addEventListener('click', function() {
            setTimeout(mmEnsureMobileBoxBanner, 50);
          });
        }
      }, 250);
    });
  }


  function boot() {
    function tryInit() {
      if (!document.getElementById('vr-sticky-atc-bar')) {
        initStickyATC(0);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(tryInit, 300);
      });
    } else {
      setTimeout(tryInit, 300);
    }

    // Safety net: also try on window load in case DOMContentLoaded already fired
    window.addEventListener('load', function() {
      setTimeout(tryInit, 500);
      setTimeout(mmInitMobileBoxBanner, 900);
    });
  }

  if (window.innerWidth < 768) boot();
})();